/* UserMetaModel */

import UserAppDataModel from './UserAppDataModel'
import UserOriginModel from "./UserOriginModel"
import UserProfileModel from "./UserProfileModel"
import UserStyleModel from "./UserColorsModel"

import { types } from 'mobx-state-tree'

/* Model Properties */
const props = {
    appData: types.optional(UserAppDataModel, {}),
    origin: types.optional(UserOriginModel, {}),
    profile: types.optional(UserProfileModel, {}),
    style: types.optional(UserStyleModel, {})
}

/* Model Actions */
const actions = (self) => ({})

const UserMetaModel = types
  .model('UserMetaModel')
  .props(props)
  .actions(actions)

  export default UserMetaModel